import { HttpContextToken } from '@angular/common/http';

export const SKIP_MAINTENANCE_INTERCEPTOR = new HttpContextToken<boolean>(() => false);
